<script lang='ts'>
import type { Session } from '../services';
import EventCard from './EventCard.svelte';
import HeaderBox from './HeaderBox.svelte';
import { EventState } from './shared';

export let sectionTitle;
export let title;
export let subtitle;
export let sessions: Session[];
export let header;
export let showDaysOfWeek;

let days = []
let filteredDays = []
let filterString = '';
let showInstructions = false;
let refs = [];

function processSchedule() {
  // Group sessions by day
  const daysGroup = sessions.reduce((days, session) => {
    const date = session.start.toLocaleDateString();
    if (!days[date]) days[date] = {sessions: [], date: session.start};
    days[date].sessions.push(session);
    return days;
  }, {});

  // Move back to array
  const daysArray = Object.keys(daysGroup).map(date => daysGroup[date]);

  days = daysArray;
  filteredDays = daysArray;
}

const scrollIntoView = ref => {
  const headerHeight = 100;
  window.scrollTo({top: ref.offsetTop - headerHeight, behavior: 'smooth'});
}

const dateToHeaderString = date => date.toLocaleString('default', { weekday: 'long', month: 'long', day: 'numeric' });
const dateToWeekday = date => date.toLocaleString('default', { weekday: 'long' })

function setFilter(query) {
  const lq = query.toUpperCase().trim();
  if (lq.length === 0) {
    filteredDays = days
    return;
  }

  filteredDays = days
    .map(day => ({
      ...day,
      sessions: day.sessions.filter(session => session.name.toUpperCase().indexOf(lq) !== -1 || session.description.toUpperCase().indexOf(lq) !== -1)
    }))
    .filter(day => day.sessions.length > 0)
}

$: if (sessions) processSchedule()
$: setFilter(filterString)
</script>

<div class="section-header">{sectionTitle}</div>

<HeaderBox {title} {subtitle} style={header} />

<div class="row tocol">
  {#if showDaysOfWeek}
    <div class="col nav-block">
      <div class="filter-box row center mb-4">
        <span class="material-icons">search</span>
        <input type="text" placeholder="Filter" bind:value={filterString} />
      </div>

      <div style="background-color: white">
      {#each days as day, i}
        <div class="nav-item" on:click={() => scrollIntoView(refs[i])}>
          <div>{dateToWeekday(day.date)}</div>
          <!-- <div>{day.date.getDate()}</div> -->
        </div>
      {/each}
      </div>
    </div>
  {/if}

  <div class="col flex-1">
    <div class="howtojoin" on:click={() => showInstructions = true}>How do I join a session?</div>
    {#each filteredDays as day, i}
      <div bind:this={refs[i]} class="day-header">{dateToHeaderString(day.date)}</div>
        
      {#each day.sessions as session}
        <EventCard {...session} />
      {/each}
    {/each}
  </div>
</div>

{#if showInstructions}
  <div class="modal" on:click={() => showInstructions = false}>
    <div class="modal-container col">
      <div class="title">How to join a session</div>
      <p>
        Ten minutes before a session starts, a “Join” button will appear below the start time. Simply click this button to automatically join the session.
      </p>

      <div class="example-card">
        <EventCard state={EventState.Live} name="Fly Like A Dragon" description="Do you want to learn to fly? I don't mean the a metaphorical sense... we're not talking about your career here. We're talking about actual flying... like a DRAGON! Now it's your chance to learn how to fly high like the pros!"
          start={new Date()}
          end={new Date(Date.now() + 60*60*1000)}
          speakers={[]} />
      </div>
      
      <div class="button" style="align-self: center">OK</div>
    </div>
  </div>
{/if}

<style lang="scss">
@import '../util';

.example-card {
  opacity: .4;
  pointer-events: none;
  margin-top: 32px;
}

.day-header {
  font-size: 28px;
  font-weight: 400;
  margin: 16px 0;
  color: black;

  @include landscape {
    margin-top: 24px;
  }
}

.title {
  margin-bottom: .5rem;
  font-weight: 700;
  font-size: 32px;
  text-transform: uppercase;
}

@include landscape {
  .tocol {
    flex-direction: column;
  }
}

.modal-container {
  background-color: white;
  border-radius: 5px;
  color: black;
  padding: 16px;
  min-width: 320px;
  min-height: 185px;
  max-width: 780px;
}

.day-header:first-child {
  margin-top: 48px;

  @include landscape {
    margin-top: unset;
  }
}

.howtojoin {
  z-index: 1;
  text-decoration: underline;
  cursor: pointer;
  color: black;
  align-self: flex-end;
  margin-bottom: -40px;

  @include landscape {
    margin-bottom: unset;
    align-self: center;
    margin: 16px 0;
  }
}

.filter-box {
  position: relative;

  > :first-child {
    position: absolute;
    pointer-events: none;
    z-index: 1;
    top: 8px;
    left: 8px;
    color: black;
  }
   input {
    font-size: 16px;
    font-weight: 300;
    padding-left: 34px;
    flex: 1;
    width: 100%;  // safari bug
  }
}


.nav-block {
  color: var(--primary);
  font-weight: normal;
  font-size: 20px;
  margin-right: 32px;
}

.nav-item {
  padding: 8px 16px;
  display: flex;
  cursor: pointer;
  color: black;
  // letter-spacing: 0.05em;
  // border-radius: 5px;

  &:hover {
    background-color: var(--secondary);
    color: var(--text-secondary);
  }

  > :first-child {
    width: 140px;
    // font-weight: bold;
    // letter-spacing: 0.05em;
  }

  > :last-child {
    flex: 1;
    font-weight: bold;
  }
}
</style>